// import { label } from 'aws-amplify' // Removed - not needed
import React, { useEffect, useState } from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import theme from '../../../../theme'
import styles from './CustomCheckBoxStyles'

export const CustomCheckBox = ({
    options,
    defaultValue,
    onChangeSelected,
}: {
    options: Array<{ key: string; value: string }>
    defaultValue: { key: string; value: string }
    onChangeSelected: (optionValue: string) => void
}) => {
    useEffect(() => {
        setChecked(getIndex(options))
    }, [defaultValue])
    const getIndex = (options: Array<{ key: string; value: string }>) => {
        if (defaultValue == null) {
            return -1
        }
        return options.findIndex((option) => option.key === defaultValue.key)
    }
    // console.log('Test', getIndex(options))
    const [checked, setChecked] = useState<number>(-1)

    useEffect(() => {
        setChecked(getIndex(options))
    }, [options])
    // console.log('Test2', checked)
    // console.log('test3', options)

    const setChange = (index: number) => {
        // console.log("Change")
        setChecked(index)
        onChangeSelected(options[index].value)
    }
    return (
        <View style={styles.flexDirectionRow}>
            {options.map((option, index) => {
                const isSelected = checked === index
                return <CustomCheckBoxItem label={option.value} index={index} checked={isSelected} onChange={() => setChange(index)} key={index} />
            })}
        </View>
    )
}

export const CustomCheckBoxItem = ({
    label,
    index,
    checked,
    onChange,
}: {
    label: string
    index: number
    checked: boolean
    onChange: (index: number) => void
}) => {
    return (
        <View style={styles.containerFlex}>
            <TouchableOpacity style={styles.containerItem} onPress={() => onChange(index)}>
                <View
                    style={[
                        styles.checkboxCircle,
                        {
                            backgroundColor: checked ? theme.colors.colorPrimary : 'transparent',
                        },
                    ]}
                ></View>

                <Text style={[styles.item, { color: checked ? theme.colors.colorPrimary : theme.colors.textSecondary }]}>{label}</Text>
            </TouchableOpacity>
        </View>
    )
}
